import { Slider, SLIDER_DEFAULTS } from '../components/slider'

const SELECTORS = Selectors({
  volunteerNews: 'element-volunteernews',
  contentSlider: 'volunteer-news-items__content-slider',
  imagesSlider: 'volunteer-news-items__images-slider'
})

const props = {
  $elements: document.querySelectorAll(SELECTORS.asClass('volunteerNews'))
}

const fn = {
  init: () => {
    const contentSliderOpts = Object.assign({}, SLIDER_DEFAULTS, {
      prevNextButtons: false,
      fade: true
    })

    const imagesSliderOpts = Object.assign({}, SLIDER_DEFAULTS, {
      autoPlay: false,
      prevNextButtons: false,
      setGallerySize: false,
      pageDots: false,
      fade: true
    })

    props.$elements.forEach(($el) => {
      const $contentSlider = $el.querySelector(SELECTORS.asClass('contentSlider'))
      const $imagesSlider = $el.querySelector(SELECTORS.asClass('imagesSlider'))

      contentSliderOpts.sync = $imagesSlider

      Slider.init($contentSlider, contentSliderOpts)
      Slider.init($imagesSlider, imagesSliderOpts)
    })
  }
}

export default {
  can: () => props.$elements.length,
  run: fn.init
}
